import { fetchSonarDataActionTypes } from '../actions/types';
import { cachedRequestByIdReducer, reducerById } from './helpers';
import { createSelector } from 'reselect';
import { keys, uniq } from 'lodash';

/**
 * Callback for reducerById. This method exists as sonar state is not mapped by id
 * and needs to be remapped to check for existing responses correctly.
 * @param {*} newState The state to parse.
 * @param {*} action The action containing the response to check the state for.
 */
export const callback = (newState, action) => {
  if (action.response.length === 0 || !action.response[0].current_build) {
    return newState;
  }
  const currentBuild = action.response[0].current_build;
  if (newState[currentBuild]) {
    newState[currentBuild] = uniq([...newState[currentBuild], ...action.response]);
  } else {
    newState[currentBuild] = action.response;
  }
  return newState;
};

const sonar = cachedRequestByIdReducer(
  fetchSonarDataActionTypes,
  'byCurrentId',
  ['request'],
  () => reducerById(
    fetchSonarDataActionTypes.success,
    () => false,
    callback
  )
);

export default sonar;

const getSonarState = state => state.sonar;

/**
 * Method to retrieve a sonar response by a desired current Id.
 * @param {*} state The state to be parsed.
 * @param {*} id The desired id.
 */
export const getSonarById = (state, id) => getSonarState(state).byCurrentId[id];

/**
 * Selector to get sonar responses mapped by current Id and baseline Id for quick lookup.
 */
export const getSonarByCurrentAndBaseline = createSelector(
  getSonarState,
  (sonar) => {
    return keys(sonar.byCurrentId).reduce((result, k) => {
      result[k] = {};
      const current = sonar.byCurrentId[k];
      current.forEach(response => {
        result[k][response.baseline_build] = result[k][response.baseline_build] ?
          result[k][response.baseline_build].concat(response) : [response];
      });
      return result;
    }, {});
  }
);


// WEBPACK FOOTER //
// src/reducers/sonar.js